module.exports = __webpack_public_path__ + "img/index01.5b28c246.png";